import { Box, Flex, FormLabel, Heading } from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeAddLiveVideoModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllCoursesRequest } from "../../../../modules/superadmin-modules/courses/Actions";
import {
  createLiveVideoRequest,
  updateLiveVideoRequest,
} from "../../../../modules/superadmin-modules/live-videos/Actions";
import { getAllPaymentsRequest } from "../../../../modules/superadmin-modules/payment/Actions";


const AddLiveVideo = ({ isAdd, data, setSelectedData }) => {
  const openLiveVideo = useSelector((state) => state.model.isOpen37);
  const isLoading = useSelector((state) => state.superadminLiveVideos.isLoading);
  const courses = useSelector((state) => state.courses.courses);
  const paymentSubjects = useSelector(
    (state) => state.superadminPayment.payments
  );

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
  const dispatch = useDispatch();

  const coursesOptions = courses?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const paymentSubjectsOptions = paymentSubjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const defaultCourse = {
    label: data?.course?.name,
    value: data?.course?.id,
  };

  useEffect(() => {
    dispatch(getAllCoursesRequest());
    dispatch(getAllPaymentsRequest());
  }, []);

  const editDefaults =
    !isAdd && data
      ? {
          title: data.title ?? "",
          zoom_link: data.zoom_link ?? "",
          course_id: data.course?.id,
          payment_subject_id: data.payment_subject?.id,
        }
      : {};

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: isAdd ? {} : editDefaults,
    shouldUnregister: false,
  });

  useEffect(() => {
    if (!isAdd && data?.id) {
      reset({
        title: data.title ?? "",
        zoom_link: data.zoom_link ?? "",
        course_id: data.course?.id,
        payment_subject_id: data.payment_subject?.id,
      });
    }
  }, [isAdd, data?.id, reset]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة فيديو مباشر" : "تعديل فيديو مباشر"}
      </Heading>
    </Box>
  );

  const onSubmit = async (values) => {
    const action = () => {
      dispatch(closeAddLiveVideoModel());
      setSelectedData({});
      reset();
    };
    const courseId =
      values?.course_id ?? data?.course?.id ?? data?.course_id;
    const paymentSubjectId =
      values?.payment_subject_id ??
      data?.payment_subject?.id ??
      data?.payment_subject_id;

    if (isAdd) {
      const formData = new FormData();
      formData.append("title", values?.title ?? "");
      formData.append("zoom_link", values?.zoom_link ?? "");
      if (courseId != null && courseId !== "") {
        formData.append("course_id", courseId);
      }
      if (paymentSubjectId != null && paymentSubjectId !== "") {
        formData.append("payment_subject_id", paymentSubjectId);
      }

      await dispatch(createLiveVideoRequest(formData, action));
    } else {
      const formData = new FormData();
      formData.append("_method", "PUT");
      formData.append("title", values?.title ?? data?.title ?? "");
      formData.append("zoom_link", values?.zoom_link ?? data?.zoom_link ?? "");
      if (courseId != null && courseId !== "") {
        formData.append("course_id", courseId);
      }
      if (paymentSubjectId != null && paymentSubjectId !== "") {
        formData.append("payment_subject_id", paymentSubjectId);
      }

      dispatch(updateLiveVideoRequest(data?.id, formData, action));
    }
  };

  const closeFunc = () => {
    dispatch(closeAddLiveVideoModel());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openLiveVideo}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="العنوان"
              defaultValues={data?.title}
              error={errors?.title?.message}
              placeholder="ادخل عنوان الفيديو المباشر"
              register={register}
              name="title"
            />
          </Box>
          <Box w="45%">
            <MainInput
              label="الرابط"
              defaultValues={data?.zoom_link}
              error={errors?.zoom_link?.message}
              placeholder="ادخل رابط الفيديو المباشر"
              register={register}
              name="zoom_link"
            />
          </Box>
          <Box w="45%">
            <FormLabel>الدورة : </FormLabel>
            <Select
              key={`course-${data?.id ?? "new"}`}
              options={coursesOptions}
              onChange={(opt) => setValue("course_id", opt?.value)}
              styles={colourStyles}
              placeholder="الدورة"
              defaultValue={defaultCourse}
            />
          </Box>
          <Box w="45%">
            <Box w="100%">
              <FormLabel>حصة الدفع : </FormLabel>
              <Select
                key={`pay-${data?.id ?? "new"}`}
                options={paymentSubjectsOptions}
                defaultValue={{
                  label: data?.payment_subject?.name,
                  value: data?.payment_subject?.id,
                }}
                onChange={(opt) =>
                  setValue("payment_subject_id", opt?.value)
                }
                styles={colourStyles}
                placeholder="payment subject"
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddLiveVideo; 